import React from 'react';
import PropTypes from 'prop-types';

import { LoginFAS } from './login-fas';

export const LOGIN_VARIANT = {
  FAS: 'fas',
};

/**
 * Login component.
 */
const Login = ({ variant, title, text, buttonText, url, onClick, dismissible }) => {
  switch (variant) {
    case LOGIN_VARIANT.FAS:
      return <LoginFAS title={title} text={text} buttonText={buttonText} url={url} onClick={onClick}/>;
  }
};

Login.propTypes = {
  variant: PropTypes.oneOf(Object.values(LOGIN_VARIANT)),
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  url: PropTypes.string,
  dismissible: PropTypes.bool,
};

Login.defaultProps = {
  variant: LOGIN_VARIANT.FAS,
  title: '',
  text: '',
  buttonText: '',
  url: '',
  dismissible: false,
};

export { Login };
